import React, { useContext, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { get } from "lodash";
import { ManageTransactionMenu, LoaderWrapper } from "../../../components";
import { withAppLayout } from "../../../hoc";
import { MANAGE_TRANSACTION_MENU } from "../../../utils";
import { ManageTransactionRoutes } from "../../../routes";
import {
  ManageTransactionProvider,
  manageTransactionStore,
  setManageTransactionSelectedMenu,
  //   setManageTradeSelectedMenu,
} from "../../../contexts";

export const ManageTransaction = (props) => {
  const { location } = props;
  const { state, dispatch } = useContext(manageTransactionStore);
  const { isFetching } = get(state, "api", {});
  const flow = get(state, "flow");

  useEffect(() => {
    dispatch(setManageTransactionSelectedMenu(location.pathname));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const isLoading = get(state, "isLoading");

  return (
    <LoaderWrapper
      isLoading={isLoading || isFetching}
      className="row manage-company-wrapper"
    >
      <Col className="h-100">
        <Row sm="12" className="h-100">
          <Col
            style={{ maxWidth: "22%" }}
            className="manage-company-column manage-menu-items"
          >
            <div className="company-name-component">{""}</div>
            <ManageTransactionMenu
              menuList={MANAGE_TRANSACTION_MENU}
              selectedMenu={get(state, "selectedMenu")}
              flow={flow}
            />
          </Col>
          <Col
            style={{ maxWidth: "78%" }}
            className="h-100 manage-menu-content"
          >
            <ManageTransactionRoutes />
          </Col>
        </Row>
      </Col>
    </LoaderWrapper>
  );
};

const ManageTransactionWithProvider = (props) => {
  return (
    <ManageTransactionProvider>
      <ManageTransaction {...props} />
    </ManageTransactionProvider>
  );
};

export default withAppLayout(ManageTransactionWithProvider);
